import React, { useState } from "react";
import { ImageOff } from "lucide-react";

import { urlDaFoto } from "./formato";

export default function FotoProduto({ url, nome, tamanho = "w-11 h-11" }) {
  const [erro, setErro] = useState(false);
  const src = urlDaFoto(url);
  if (!src || erro) {
    return (
      <div className={`${tamanho} rounded-lg bg-muted flex items-center justify-center shrink-0`} aria-hidden="true">
        <ImageOff className="w-4 h-4 text-muted-foreground/60" />
      </div>
    );
  }
  return <img src={src} alt={nome || ""} loading="lazy" onError={() => setErro(true)} className={`${tamanho} rounded-lg object-cover shrink-0`} />;
}
